// Treatment arms of experiments.
export const TREATMENT_ARMS = Object.freeze({
  singleHarnessForStationAndAudioAdsEnabled: 11172, // Experiment group: "sxm_player_web_station_playback". Treatment arm: "single_harness_for_station_and_audio_ads"
  singleHarnessForUnencryptedStationAndAudioAdsEnabled: 11984, // Experiment group: "sxm_player_web_station_playback". Treatment arm: "single_harness_for_unencrypted_stations_and_audio_ads"
  podcastsOnSxmPlayerEnabled: 12345, // This is a mock ID for now, will update when we create Experiment group: "sxm_player_web_station_playback". Placeholder for eventual experiment we will create
  sxmEncryptedStationFragmented: 10670, // Experiment group: "sxm_player_web_station_playback". Treatment arm: "encrypted_mp4_fragmented"
  sxmUnencryptedMediaelementPlayback2021: 11238, // Experiment group: "sxm_player_web_station_playback". Treatment arm: "unencrypted_sxm_media_element_2021"
  sxmUnencryptedWAAPlayback2021: 11239, // Experiment group: "sxm_player_web_station_playback". Treatment arm: "unencrypted_sxm_waa_2021"
  sxmFetchDownloader: 11444, // Experiment group: "sxm_player_web_on_demand_playback". Treatment arm: "fetch_downloader"
  sxmEncryptedStationFetchDownloader: 11356, // Experiment group: "sxm_player_web_station_playback". Treatment arm: "encrypted_station_fetch_downloader"
  sxmFetchDownloaderV2: 11445, // Experiment group: "sxm_player_web_on_demand_playback". Treatment arm: "fetch_downloader_v2"
  sxmEncryptedStationFetchDownloaderV2: 11434, // Experiment group: "sxm_player_web_station_playback". Treatment arm: "encrypted_station_fetch_downloader_v2"
  sxmEncryptedStationFetchDownloaderV2MultipleHarness: 11637, // Experiment group: "sxm_player_web_station_playback". Treatment arm: "encrypted_station_fetch_downloader_v2_multiple_harness"
  audioAdsSkippabilityEnabled: 12088, // Experiment group: #10705 "web_audio_ads_skippability". Treatment arm: "skippable_audio_ads_2"
  webPingRadioHealth: 11947, // // Experiment group: "web_ping_radio_health". Treatment arm: "web_ping_radio_health",
  measurementThroughOmsdk: 12030, // Experiment group "web_measurement_through_omsdk", Treatment arm "web_measurement_through_omsdk"
  stationAPST2Migration: 12315, // Experiment group "web_aps_migration_t2_station", Treatment arm T2_users"
  stationAPST3Migration: 12316, // Experiment group "web_aps_migration_t3_station", Treatment arm T3_users"
  webAPSMigrationMM4: 12403, // Experiment group "web_aps_migration_mm4", Treatment arm "web_aps_migration_mm4"
  web_ads_uid2: 12587,
  debug_webca_2503_treatment: 12684,
  web_cancel_flow: 12633,
  web_payment_page_updates: 12632,
  web_switch_plans_modal_updates: 12640,
} as const);

// Experiments for the current A/B framework
export const EXPERIMENT_GROUPS = Object.freeze({
  webAppIntegrity: 10576, // human_security_web_app_integrity
  migrateABFrameworkPhase2: 1234,
  adsDisableRID: 10478,
  sxmPlayerWebStationPlayback: 10292,
  sxmPlayerWebOnDemandPlayback: 10578,
  webAudioAdsSkippability: 10705,
  webPingRadioHealth: 10704,
  measurementThroughOmsdk: 10740,
  stationAPST2Migration: 10851,
  stationAPST3Migration: 10852,
  webAPSMigrationMM4: 10874,
  web_ads_uid2: 10938,
  debug_webca_2503_experiment: 10987,
  web_cancel_flow: 10958,
  web_payment_page_updates: 10957,
  web_switch_plans_modal_updates: 10964,
} as const);
